<template>

  <div>
    <el-row>

       <el-col :span="24">

          <data-table
            title="Tickets"
            table-ref="tickettable"
            icon="fa fa-headset"
            :title-heading="titleHeading"

            :url="url"
            :fields="fields"

            sort-field="target"

            :options="options"

            :add-action="action"
            :add-props="addProps"

            :bottom-comp="bottomComp"
            :bottom-comp-props="bottomCompProps"

            search-placeholder="Priority, Category, Type, Sub-Type..."
            detail-component="ticket-detail-row">

              <template slot="shortName" slot-scope="props">
                <org-badge :organisation="props.rowData.organisation" />
              </template>

              <template slot="contractor" slot-scope="props">
                <org-badge v-if="props.rowData.contractor" :organisation="props.rowData.contractor" />
              </template>

              <template slot="opened" slot-scope="props">

               <el-popover v-if="props.rowData.opened" trigger="hover" placement="left">
                 <table v-if="props.rowData.opened || props.rowData.target">
                   <tr v-if="props.rowData.opened"><td>Opened</td><td><b>{{formatDate(props.rowData.opened)}}</b></td></tr>
                   <tr v-if="props.rowData.target"><td>Target</td><td><b>{{formatDate(props.rowData.target)}}</b></td></tr>
                   <tr v-if="props.rowData.completedDate"><td>Completed</td><td><b>{{formatDate(props.rowData.completedDate)}}</b></td></tr>
                 </table>
                  <el-button slot="reference">{{props.rowData.days}}</el-button>
               </el-popover>

              </template>

            </data-table>

       </el-col>
    </el-row>

  </div>

</template>


<script>
import Vue from 'vue'

Vue.component('ticket-controls', TicketControls)
Vue.component('ticket-detail-row', TicketDetails)

import SiteMixins from '@/mixins/SiteMixins'

import TicketControls from '@/components/tables/controls/TicketControls'
import TicketDetails from '@/components/tables/details/TicketDetails'
import TicketAction from '@/components/actions/TicketAction'

export default {

  mixins: [SiteMixins],

  components: {
    TicketAction,
    TicketControls
  },

  props: {
    status: {
      type: String,
      default: null
    },

    priority: {
      type: String,
      default: null
    },

    titleHeading: {
      type: String,
      default: 'h5'
    },

    siteId: {
      type: Number,
      default: null
    },

    assetId: {
      type: Number,
      default: null
    },

    ownerId: {
      type: Number,
      default: null
    },

    showOwner: {
      type: Boolean,
      default: true
    },

    hideSite: {
      type: Boolean,
      default: false
    },

    editMode: {
      type: Boolean,
      default: false
    },

    processKey: {
      type: String,
      default: 'ticket'
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    bottomComp: {
      type: Object,
      default: null
    },

    bottomCompProps: {
      type: Object,
      default: null
    }
  },

  computed: {
    url: function () {
      // /tickets/site/{siteId}/assets/{assetId}/{orgId?}
      if (!this.status && !this.priority) {
        return '/tickets' +
        (this.siteId ? '/site/' + this.siteId : '') +
        (this.equipId ? '/assets/' + this.equipId
        : '')
      } else {
        return '/tickets/status/' + this.status +
        (this.priority ? '/' + this.priority : '') +
        (this.orgId ? '/' + this.orgId : '')
      }
    }
  },


  watch: {

    ownerId: function (id) {
//      console.log('watch ownerId', id)
      this.orgId = !this.isTowerCo() ? this.org().id : id
    }

  },


  data () {
    return {
      options: {
        processKey: this.processKey
      },
      action: TicketAction,
      orgId: this.isTelco() ? this.org().id : this.ownerId,
      addProps: {
        editMode: this.editMode,
        siteId: this.siteId,
        ownerId: this.ownerId,
        assetId: this.assetId,
        readOnly: this.readOnly,
        rowData: null
      },
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
//          titleClass: 'hidden-sm-and-down',
//          dataClass: 'hidden-sm-and-down text-center',
          callback: this.formatStatus
        },
        {
          name: 'category',
          title: 'Category',
          sortField: 'category',
          dataClass: 'text-center',
          callback: this.formatCategory
        },
        {
          name: 'priority',
          title: 'Priority',
          sortField: 'priority',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down text-center',
          callback: this.formatPriority
        },
        {
          name: 'site.siteName',
          title: 'Site',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          visible: !this.hideSite
        },
        {
          name: '__slot:opened',
          title: 'Days Open'
        },
        {
          name: '__slot:shortName',
          title: 'Reported by',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          visible: this.showOwner
        },
        {
          name: '__slot:contractor',
          title: 'Contractor',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: '__component:ticket-controls',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          title: ''
        }
      ]
    }
  },   // data
/*
  created () {
    console.log('TicketsTable: status: ', this.status, 'priority:', this.priority, 'ownerId: ', this.ownerId, 'orgId', this.orgId)
  }
*/
}

</script>



// WEBPACK FOOTER //
// TicketsTable.vue?21e21664